import { z } from 'zod';
import { DiscountType, InventoryItemStatus } from '@trnsact/trnsact-shared-types';
import { equipmentStandardSingleInfoSchema } from './equipmentStandardInfoSchema';

export const equipmentDeliverySchema = z.object({
  state: z.string().nullable(),
  city: z.string().trim().max(100, 'City must be 100 characters or fewer').nullable(),
  streetAddress: z.string().trim().max(200, 'Address must be 200 characters or fewer').nullable(),
  country: z.string().trim().max(100, 'Country must be 100 characters or fewer').nullable(),
  postalCode: z.string().trim().max(20, 'Postal code must be 20 characters or fewer').nullable(),
});

export const commonInfoSchema = z.object({
  vin: z.string(),
  stockId: z.string(),
  saleCost: z.number(),
  condition: z.string(),
  retailPrice: z.number(),
  description: z.string(),
  wholeSaleCost: z.number(),
  class: z.string().nullable(),
  mileage: z.number().nullable(),
  quantity: z
    .number()
    .nullable()
    .refine((val): val is number => val !== null, { message: 'Required field' }),
  inventoryItem: z.object({
    status: z.nativeEnum(InventoryItemStatus),
    inventoryId: z.string().nullable(),
    inventoryOption: z.object({ label: z.string(), value: z.string() }).nullable(),
  }),
});

export const equipmentAttachmentSchema = z.object({
  type: z.string(),
  model: z.string(),
  unitCost: z.number(),
  retailPrice: z.number(),
  category: z.string(),
  manufacturer: z.string(),
  quantityPerAsset: z.number(),
  discountValue: z.number(),
  discountType: z.nativeEnum(DiscountType),
});

export const equipmentFormSchema = z
  .object({
    commonInfo: commonInfoSchema,
    attachments: z.array(equipmentAttachmentSchema),
    calcPricing: z.object({
      retail: z.object({
        total: z.number(),
        attachments: z.number(),
      }),
      customer: z.object({
        total: z.number(),
        equipment: z.number(),
        attachments: z.number(),
      }),
      wholesale: z.object({
        total: z.number(),
        attachments: z.number(),
      }),
    }),
  })
  .merge(equipmentStandardSingleInfoSchema);
